import axios from 'axios'
import constants from '../../../constants'

const getBiologicalCertificate = async (customerNumber: string, doctorName: string) => {
  const { data } = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/biological-monitoring/certificate`, { doctorName }, { responseType: 'blob' })
  return data
}

const getBiologicalCertificateCount = async (customerNumber: string) => {
  const { data } = await axios.get(
    `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/biological-monitoring/count`
  )
  return data.count
}

const getAnnualReports = async (customerNumber: string) => {
  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/biological-monitoring/annual-report`)
  return data
}

const getQuarterlyReports = async (customerNumber: string) => {
  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/biological-monitoring/quarterly-report`)
  return data
}

const downloadReport = async (customerNumber: string, options: { fromDate?: string, toDate?: string, autoclaveId?: number }) => {
  const response = await axios.post(
    `${constants.ONTRAQ_API_URL}/api2/${customerNumber}/biological-monitoring/biological-report`,
    options,
    { responseType: 'blob' }
  )

  const report: Blob = response.data

  return report
}

export {
  getBiologicalCertificate,
  getBiologicalCertificateCount,
  getAnnualReports,
  getQuarterlyReports,
  downloadReport
}